import { NURSE_TRANSFER_RESOURCE } from '../api/resources';
import { selectNurseTransferById } from './nurseTransfersSlice';

export const selectTransferByDeploymentId = (state, deploymentId, type) => {
    const transferId = state[NURSE_TRANSFER_RESOURCE].byDeploymentId[type][deploymentId];
    return transferId ? selectNurseTransferById(state, transferId) : null;
};
